const OfferLineBreakdown = {
  paid_and_free: '{{paidQuantity}} × {{price}} payé · {{freeQuantity}} × gratuit',
  all_free: '{{freeQuantity}} × gratuit',
};

export default OfferLineBreakdown;
